import { render, staticRenderFns } from "./MotorConfigurator.vue?vue&type=template&id=5c5682e2&scoped=true"
import script from "./MotorConfigurator.vue?vue&type=script&lang=js"
export * from "./MotorConfigurator.vue?vue&type=script&lang=js"
import style0 from "./MotorConfigurator.vue?vue&type=style&index=0&id=5c5682e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5682e2",
  null
  
)

export default component.exports